export default __webpack_public_path__ + "static/stayfree-logo-79321535b86d322227226514d9616930.png";